export const officialProviderUrls = [
  "https://nuxt.studio",
  "https://dev.nuxt.studio"
];
